"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Colors = {
  'black': '#000000',
  'blue': '#38ccf7',
  'blue-d': '#05b5dd',
  'green': '#30bc5b',
  'green-d': '#28a049',
  'grey': '#6e6d6d',
  'grey-d': '#403c3c',
  'grey-l': '#a0a2a2',
  'grey-xl': '#dee2e0',
  'grey-xxl': '#e7ebeb',
  'grey-xxxl': '#f8fbfb',
  'orange': '#ffaa00',
  'orange-d': '#ff8c00',
  'pink': '#ff61ff',
  'pink-d': '#dc4cdc',
  'purple': '#994efc',
  'purple-d': '#7940c2',
  'red': '#d31642',
  'red-d': '#b2143d',
  'teal': '#6affd6',
  'teal-d': '#2aedcc',
  'white': '#ffffff',
  'yellow': '#ffe94c',
  'yellow-d': '#fadb00',
  // Significance (for plots)
  'ns': 'rgba(236, 236, 236, .7)',
  '*': 'rgba(184, 237, 255, .85)',
  '**': 'rgba(122, 228, 255, .85)',
  '***': 'rgba(56, 204, 247, .85)',
  '****': 'rgba(8, 181, 221, .85)'
};
var _default = Colors;
exports.default = _default;